export default "__VITE_ASSET__BVZ6kd5j__"